const $$splitComponentImporter = () => import('/Users/vthang/projects/marvy/marvy_mono/apps/pinktool/src/routes/account/login.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/account/login")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
type LoginForm = {
  email: string;
  password: string;
};